export default __webpack_public_path__ + "static/media/snn.d2f487c6.png";